import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import StoreProvider from './StoreProvider';
import '@livingdesign/react/dist/styles.css';


const container = document.getElementById('root');
const root = createRoot(container);
root.render(<StoreProvider />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
